// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"684536ef","453":"a65dc3e7"}[chunkId] + ".chunk.js";
};